import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { takeWhile } from 'rxjs/operators';
import { ActionsAnalyticsService, CART_TYPES, CustomizableMobilePlan, MobileCustomPlansServiceNoSync, MobilePlanItem, PURCHASE_INTENT } from '@ztarmobile/zwp-service-backend';
import { ACTIVATION_ROUTE_URLS, ROUTE_URLS, SHOP_ROUTE_URLS, SUPPORT_ROUTE_URLS } from '../../../app.routes.names';
import { MetaService } from '../../../../services/meta-service.service';
import { ContentfulService } from '../../../../services/contentful.service';
import { ModalHelper } from '../../../../services/modal-helper.service';
import { AppState } from '../../../../app/app.service';
import { SimpleAuthService } from '@ztarmobile/zwp-services-auth';
import { AngularFireAuth } from '@angular/fire/compat/auth';

@Component({
  selector: 'app-new-plan-shop',
  templateUrl: './new-plan-shop.component.html',
  styleUrls: ['./new-plan-shop.component.scss']
})
export class NewPlanShopComponent implements OnInit, OnDestroy {

  public userCart: CustomizableMobilePlan;
  public zipCode = '';
  public processingRequest = false;
  public invalidZipCode = false;
  public changeMessage = false;
  public questionId: string;
  public questionIdParam: string;
  public plansFaqs;
  public collapsed = false;
  public planB = false;
  public filteredPlans: Array<MobilePlanItem>;
  public monthlyPlans: Array<MobilePlanItem>;
  public quarterlyPlans: Array<MobilePlanItem>;
  public halfYearPlans: Array<MobilePlanItem>;
  public yearlyPlans: Array<MobilePlanItem>;
  public jsonLDString: any;
  public allFilteredPlans: any;
  public userHasDevice = false;
  public firstThreeQuestions;
  public restQuestions;
  public showMore = false;

  private activationFlow = false;
  private allBasePlans: Array<MobilePlanItem>;
  private alive = true;
  tracked: boolean;

  constructor(private route:ActivatedRoute, private router: Router, private mobilePlansService: MobileCustomPlansServiceNoSync, private metaService: MetaService,
    private contentfulService: ContentfulService, private modalHelper: ModalHelper, private analyticsService: ActionsAnalyticsService, private appState: AppState,
    private simpleAuthService: SimpleAuthService, private angularFireService: AngularFireAuth) {
    this.mobilePlansService.currentPlan.pipe(takeWhile(() => this.alive)).subscribe((cart) => {
      this.userCart = cart;
      this.userHasDevice = !!this.userCart.planDevice && !!this.userCart.planDevice.skuIdentifier && !!this.userCart.planDevice.skuNumber;
    });
  }

  ngOnInit(): void {
    this.route.params.pipe(takeWhile(() => this.alive)).subscribe((params: Params) => {
      if (!!params[ACTIVATION_ROUTE_URLS.PARAMS.ACTIVATION]) {
        this.activationFlow = true;
      }
    });
    this.contentfulService.getQuestionsByCategoryId('faqs', 'plans questions').subscribe(questions => {
      if (!!questions) {
        const allQuestions = questions[0].fields.questions;
        this.firstThreeQuestions = allQuestions.slice(0, 3);
        this.restQuestions = allQuestions.slice(3);
      }
    });

    this.metaService.createCanonicalUrl();
    this.mobilePlansService.isConfigurationReady.pipe(takeWhile(() => this.alive)).subscribe((isReady) => {
      if (isReady) {
        this.allBasePlans = this.mobilePlansService.allBasePlans;
        this.prepareShemaData();
      }
    });
  }

  ngOnDestroy(): void {
    this.alive = false;
  }
  public goToInternationalCalling(rates?: boolean): void {
    if (rates) {
      window.open(`${SUPPORT_ROUTE_URLS.BASE}/${SUPPORT_ROUTE_URLS.INTERNATIONAL_CALLING};${ROUTE_URLS.PARAMS.INTERNATIONAL_CALL_LANDING}=${rates}`);
    } else {
      window.open(`${SUPPORT_ROUTE_URLS.BASE}/${SUPPORT_ROUTE_URLS.INTERNATIONAL_CALLING}`);
    }
  }

  public onZipCodeChange(): void {
    if (!this.processingRequest) {
      this.invalidZipCode = !(/^\d{5}(-\d{4})?$/.test(this.zipCode));
    }
  }

  public goToCoverage(): void {
    const params = {};
    params[ACTIVATION_ROUTE_URLS.PARAMS.ZIP_CODE] = this.zipCode;
    this.router.navigate([`${SUPPORT_ROUTE_URLS.BASE}/${SUPPORT_ROUTE_URLS.COVERAGE}`, params]);
  }

  public toggleActive(targetId, answerId): void {
    if (this.questionId === targetId && !this.collapsed) {
      this.questionId = 'q0';
    } else {
      this.questionId = targetId;
      this.collapsed = false;
      this.callRichText(answerId);
    }
  }
  public addToCart($event): void {
    this.checkUser($event);
  }

  private checkUser(plan): void {
    this.simpleAuthService.userState.pipe(takeWhile(() => this.alive)).subscribe((authState) => {
      const isLoggedIn = !!authState && !authState.isAnonymous;
      if (!isLoggedIn) {
        this.angularFireService.signInAnonymously().then((user) => {
          setTimeout(() => {
            this.checkCart(plan);
          }, 1000);
        });
      } else {
        this.checkCart(plan);
      }
    });
  }
  private addPlan(plan): void {
    sessionStorage.setItem('planID', JSON.stringify(plan.id));
    if (!!this.userHasDevice) {
      this.mobilePlansService.setBasePlan(plan);
      this.mobilePlansService.setCartType(CART_TYPES.NEW_PLAN);
      this.mobilePlansService.setAutoRenewPlan(true);
    }  if (!this.activationFlow) {
      this.mobilePlansService.setSimCard('');
    } else {
      this.mobilePlansService.seteSIM(false);
    }
    const price = plan.subscriptionCycles * plan.price;
    if (!this.tracked) {
      this.tracked = true;
      this.analyticsService.trackAddToCartGA4(PURCHASE_INTENT.NEW, [plan], price);
    }
  }

  private checkCart(plan): void {
    // eslint-disable-next-line
    if (!!this.userCart && !!this.userCart.cartType && this.userCart.cartType != CART_TYPES.NEW_PLAN) {
      this.modalHelper.showConfirmMessageModal('Clear Cart', 'Adding new plan will remove other items in your cart. Do you want to proceed?', 'Yes', 'No', 'clean-cart-modal')
        .afterClosed().subscribe((result) => {
          if (!!result) {
            this.clearCart();
            setTimeout(() => {
              this.addPlan(plan);
              if ((!this.userCart.planDevice) || (!!this.userCart.planDevice && !this.userCart.planDevice.id) ||
              (!!this.userCart.planExpectedDevice && !this.userCart.planExpectedDevice.id)) {
              this.router.navigate([`${SHOP_ROUTE_URLS.BASE}/${SHOP_ROUTE_URLS.CHECK_PHONE}`]);
             } else {
              this.router.navigate([`${SHOP_ROUTE_URLS.BASE}/${SHOP_ROUTE_URLS.CART}`]);
            }
            }, 500);
          }
        }, (error) => {
          console.error('error', error);
          return false;
        });
    } else {
      this.addPlan(plan);
      this.mobilePlansService.setActivePlanId('');
      if ((!this.userCart.planDevice && !this.userCart.planExpectedDevice) || (!!this.userCart.planDevice && !this.userCart.planDevice.id) ||
        (!!this.userCart.planExpectedDevice && !this.userCart.planExpectedDevice.id)) {
        this.router.navigate([`${SHOP_ROUTE_URLS.BASE}/${SHOP_ROUTE_URLS.CHECK_PHONE}`]);
      } else {
        this.router.navigate([`${SHOP_ROUTE_URLS.BASE}/${SHOP_ROUTE_URLS.CART}`]);
      }
    }
  }
  private clearCart(): void {
    const removedItems = [];
    if (this.userCart.cartType !== CART_TYPES.PLAN_ITEMS) {
      removedItems.push(this.userCart.basePlan);
    } else {
      if (this.userCart.simsQuantity > 0) {
        removedItems.push({ id: 'SIMFRP4GLTE', quantity: this.userCart.simsQuantity, price: 10, type: 'plan-item', title: 'SIM CARD' });
      }
      if (!!this.userCart.addOns) {
        removedItems.push(this.userCart.addOns);
      }
    }
    this.analyticsService.trackRermoveFromCartGA4(removedItems);
    this.mobilePlansService.setSimPurchaseQuantity(0);
    this.mobilePlansService.setAddonsList(null, this.userCart);
    this.mobilePlansService.setActivePlanId('');
    this.appState.clearSessionStorage();
  }
  private callRichText(id): void {
    this.contentfulService.getRichText('questions', id);
  }
  private prepareShemaData(): void {
    /* eslint-disable quote-props */
    const plansOffers = [];
    this.filteredPlans?.map((plan) => plansOffers.push({
      '@type': 'Offer',
      'sku': plan.id,
      'price': !!plan.subscriptionCycles && plan.subscriptionCycles > 1 ? plan.promoMoPrice * plan.subscriptionCycles : plan.price,
      'priceCurrency': 'USD',
      'availability': 'https://schema.org/OnlineOnly',
      'image': `https://freeupmobile.com/assets/icon/plan_thumbnail.svg`,
      'shippingDetails': [
        {
          "@context": "https://schema.org",
          "@type": "OfferShippingDetails",
          "doesNotShip": true,
        }],
      'hasMerchantReturnPolicy': false
    })
    );
    const data = {
      '@type': 'Product',
      'name': 'FreeUp Mobile plans',
      'description': `Need an affordable cell phone plan with fast speeds, international calling, and more? Compare FreeUp Mobile's best and most affordable wireless service plans.`,
      'offers': plansOffers
    };
    this.jsonLDString = this.appState.setJsonLdData(data);
  }
}
